
<v-app id="app-container">
	<component :is="this.$route.meta.layout || 'div'">
		<router-view />
	</component>
</v-app>
